(function () {
  // Offer countdown: counts down from N minutes per visitor, remembered across reloads.
  var timers = document.querySelectorAll('[data-lp-countdown]');
  if (!timers.length) return;
  var minutes = parseInt(timers[0].getAttribute('data-minutes'), 10) || 15;
  var key = 'lp_offer_end';
  var end;
  try { end = parseInt(localStorage.getItem(key), 10); } catch (e) {}
  if (!end || end < Date.now()) {
    end = Date.now() + minutes * 60000;
    try { localStorage.setItem(key, String(end)); } catch (e) {}
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var m = pad(Math.floor(left / 60)), s = pad(left % 60);
    timers.forEach(function (t) {
      var mm = t.querySelector('[data-mm]'), ss = t.querySelector('[data-ss]');
      if (mm) mm.textContent = m;
      if (ss) ss.textContent = s;
    });
  }
  tick();
  setInterval(tick, 1000);
})();
